export function BootSequence({
  bootVisible,
  bootExiting,
  bootTermVisible,
  bootLineCount,
  onFinish,
}) {
  if (!bootVisible) return null

  return (
    <div id="boot" className={bootExiting ? 'gone' : ''} onClick={onFinish} role="presentation">
      <div className={`testcard ${bootTermVisible ? 'hide' : ''}`} id="testcard">
        <i /><i /><i /><i /><i /><i /><i />
      </div>
      <div className="boot-term" style={{ display: bootTermVisible ? 'block' : 'none' }}>
        <div className="sys">ARIA</div>
        <div className="sub">TICKET INTELLIGENCE · NEURAL CONSOLE v2.9</div>
        <div className="hr" />
        <div className={`ln ${bootLineCount >= 1 ? 'show' : ''}`}>CREATOR SIGNATURE ·············· <span className="ok">[VERIFIED]</span></div>
        <div className={`ln ${bootLineCount >= 2 ? 'show' : ''}`}>REPOSITORY INDEX ··············· <span className="ok">[SYNCED · 4,812 files]</span></div>
        <div className={`ln ${bootLineCount >= 3 ? 'show' : ''}`}>JIRA / ASANA LINK ·············· <span className="ok">[STABLE]</span></div>
        <div className={`ln ${bootLineCount >= 4 ? 'show' : ''}`}>NEURAL LINK ···················· <span className="gn">[ONLINE]</span></div>
        <div className="hr" />
        <div className={`ln ${bootLineCount >= 5 ? 'show' : ''}`}><span className="gn">ARIA IS AWAKE.</span> TALK OR TYPE — I&apos;LL DRAFT THE TICKET.</div>
        <div className={`ln ${bootLineCount >= 6 ? 'show' : ''}`}>ENTERING CONSOLE<span className="cur" /></div>
      </div>
      <div className="skip">PRESS SPACE OR ESC TO SKIP</div>
    </div>
  )
}
